import Scrollbar from './scrollbar.js';

let Popup = {
    open: function (idPopup) {
        var $popup = $('[data-popup-id=' + idPopup + ']'),
            $popupContainer = $popup.closest('[data-popup-container]');

        if (Popup.isOpen()) {
            // если переход из одного попапа в другой, убираем только сам попап, оверлей не дергаем
            $('[data-popup-id]').removeClass('open');
        }

        // display popup before animate
        $popupContainer.addClass('popup_open');

        $('body')
            .addClass('page_overflow')
            .addClass('page_popupopen');

        if($popupContainer.hasClass('popup_loading')){
            $popupContainer.removeClass('popup_loading');
        }

        if (Scrollbar.isActive()) {
            $('body').css('padding-right', Scrollbar.getWidth() + 'px');
        }

        // animate show
        $popup.addClass('open');
        $('.popup__overlay').addClass('open');
    },
    close: function (idPopup) {
        var $popup = $('[data-popup-id=' + idPopup + ']');

        // animate hide
        $popup.removeClass('open');
        $('.popup__overlay').removeClass('open');

        setTimeout(function(){

            // hide popup after animate
            $popup.closest('[data-popup-container]').removeClass('popup_open');

            $('body')
                .removeClass('page_overflow')
                .removeClass('page_popupopen')
                .removeAttr('style');

            let emailSubscriptionsNewsForm = $('[data-email-subscriptions-news-form]');  
            if(emailSubscriptionsNewsForm.length){
                emailSubscriptionsNewsForm.val('');
            }

            let messageContainer = $('[data-form-subscriptions-message]');
            if(messageContainer.length){
              messageContainer.html('');
            }
        }, 300);
    },
    isOpen: function () {
        return $('body').hasClass('page_popupopen');
    },
    bind: function () {
        //open popup
        $('body').on('click', '[data-popup]', function(e){
            e.preventDefault();

            var idPopup = $(this).data('popup');
            Popup.open(idPopup);
        });

        //close popup
        $('body').on('click', '[data-popup-close]', function(e){
            e.preventDefault();

            var thisPopup = $(e.target).closest('[data-popup-id]'),
                    idPopup = thisPopup.data('popup-id');

            Popup.close(idPopup);
        });


        //close popup - клик за пределами попапа
        $('body').on('click', '.popup__content', function(e){

            if($(e.target).closest('.popup__wrap').length || !($('body').hasClass('page_popupopen'))) return;

            var thisPopup = $(e.target).closest('[data-popup-id]'),
                    idPopup = thisPopup.data('popup-id');

            Popup.close(idPopup);
        });
    }
}


$(document).ready(function ($) {

    Popup.bind();

    $(window).resize(function (event) {

        if (Popup.isOpen()) {
            if (Scrollbar.isActive()) {
                $('body').css('padding-right', Scrollbar.getWidth() + 'px');
            } else {
                $('body').removeAttr('style');
            }
        }
    });

    $(window).on('load', function(){
        $('[data-popup-container]').removeClass('popup_loading');
    })
});

export default {
    bind: Popup.bind,
    open: Popup.open,
    close: Popup.close,
    isOpen: Popup.isOpen
};



// WEBPACK FOOTER //
// ./components/popup.js